import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { StudentSearchComponent } from '../../../../shared-components/student-search/student-search.component';
import { ReportQueueComponent } from '../../report-queue/report-queue.component';
import { ReportingService } from '../../reporting.service';
import { ReportV9 } from '../../models/report-v9.model';
import { V9ReportParameter } from '../../models/v9-report-parameter.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { V9ParameterRows, V9ParameterRow } from '../../models/v9-parameter-row.model';
import { System } from '../../../../shared-components/System';
import { YearService } from '../../../../shared-components/year/year.service';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { GradebookStudent } from '../../../../classroom360/gradebook/v9/models/gradebook-student.model';
import { V9LetterReportParametersComponent } from './v9-letter-report-parameters/v9-letter-report-parameters.component';
import { GenericListItem, GenericList } from '../../../../shared-components/generic-list-selector/generic-list.model';
import { GenericListSelectorComponent } from '../../../../shared-components/generic-list-selector/generic-list-selector.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DataQueryField } from '../../../../classroom360/data-query/data-query-field.model';
import { Year } from '../../../../shared-components/year/year.model';
import { SchoolYearSettings } from '../../../../shared-components/year/school-year-settings.model';
import { StaffSearchComponent } from '../../../../shared-components/staff-search/staff-search.component';
import { Staff } from '../../../../shared-components/staff-search/staff.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-v9-report-parameters',
  templateUrl: './v9-report-parameters.component.html',
  styles: []
})
export class V9ReportParametersComponent implements OnInit, OnDestroy {

  selectedReport: ReportV9;
  reportForSaveRCM: ReportV9;
  refreshGrid: ReportV9;
  reportParameters: V9ReportParameter[] = [];
  chunkedParameters: V9ParameterRows;
  selectedSiteSectionId = 0;
  selectedStudentIds: GradebookStudent[] = [];
  errors: ErrorList[] = [];
  showLegend = false;
  selectAllGridRecords = false;
  gridDataMatDatasource = new TylerMatTableDataSource();
  gridDataSource: any[] = [];
  columnToDisplay: string[] = [];
  tabNames: string[] = [];
  blnIsParameterLink = false;
  dataColumns: DataQueryField[] = [];
  selectedStudentIdsArray: number[] = [];
  blnSaveReportCardMessage = false;
  blnReportCardsGrade = false;
  defaultYear: Year;
  schoolYearSettings: SchoolYearSettings;
  @ViewChild(MatSort) set sort(val: MatSort) {
    this.gridDataMatDatasource.sort = val;
  }
  @ViewChild(MatSort) sortValue: MatSort;
  studentNameFormat: string;
  studentMiddleNameFormat: string;
  ShowNickname: string
  imageIconName: string;
  constructor(
    private reportingService: ReportingService,
    private dialogRef: MatDialogRef<V9ReportParametersComponent>,
    private dialog: MatDialog,
    private yearService: YearService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private studentListSelectorDialog: MatDialog,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.defaultYear = this.yearService.defaultYear;
    if (this.data != undefined) {
      this.selectedReport = this.data.Report;
      this.selectedSiteSectionId = this.data.selectedSectionId == undefined ? 0 : this.data.selectedSectionId;
      this.selectedStudentIds = this.data.studentSelection;
      this.blnReportCardsGrade = this.data.blnReportCardsGrade == undefined ? false : this.data.blnReportCardsGrade;
    }
    if (this.selectedSiteSectionId != 0) {
      this.getV9StudentNameFormat();
    }
    this.getV9ReportParameters();
  }

  ngOnDestroy() {
  }

  getV9ReportParameters() {
    this.reportingService.getV9ReportParameters(this.selectedReport.Id, this.selectedSiteSectionId, 0).subscribe(result => {
      this.reportParameters = result;
      this.reportParameters.forEach(obj => {
        if (obj.TabName != '' && obj.TabName != undefined) {
          if (!this.tabNames.includes(obj.TabName)) {
            this.tabNames.push(obj.TabName);
          }
        }
      });
      if (this.tabNames.length > 0) {
        if (this.tabNames.includes('Report Card Messages')) {
          this.blnSaveReportCardMessage = true;
          this.reportForSaveRCM = this.selectedReport;
        }
        if (this.tabNames.includes('Messages')) {
          this.reportForSaveRCM = this.selectedReport;
        }
      }
      this.setParameterRows();
    });
  }

  getV9StudentNameFormat() {
    this.reportingService.getV9ReportParameterStudentNameFormat(this.selectedSiteSectionId).subscribe(result => {
      const studentName = result.split(',');
      if (studentName.length > 0) {
        this.studentNameFormat = studentName[0];
        this.studentMiddleNameFormat = studentName[1];
        this.ShowNickname = studentName[2];
      }
    });
  }

  getParameterStyle(parameter: V9ReportParameter): object {
    let obj: object = null;
    if (parameter != null && parameter.ParameterStyle != '') {
      obj = JSON.parse('{' + parameter.ParameterStyle + '}');
    }

    return obj;
  }

  runReportClick() {
    const reportType = this.reportParameters.filter(o => o.ColumnName == 'reportType' || o.ColumnName == 'PrintLetters' || o.ColumnName == 'CustomInfo')[0];
    if (reportType != undefined && (reportType.Value == 'Letters' || reportType.Value == 'Export' || reportType.Value == true)) {
      alert('Not yet implemented!');
    }
    else {
      this.errors = [];
      const reportFullSheets = this.reportParameters.filter(o => o.ParameterName == 'strFullSheet')[0];
      if (reportFullSheets != undefined) {
        if (reportFullSheets.Value == 'GridPage') {
          this.selectedReport.WorkflowReport = false;
        }
      }
      const journalReportType = this.reportParameters.filter(o => o.ParameterName == 'strReportType')[0];
      if (journalReportType != undefined) {
        if (journalReportType.Value == 'Journal') {
          const emailOptions = this.reportParameters.filter(o => o.ParameterName == 'strEmailOptions')[0];
          if (emailOptions != undefined && emailOptions.Value == 'SendEmailAndLetter') {
            this.selectedReport.WorkflowReport = false;
          }
        }
        if (journalReportType.Value == 'P') {
          this.selectedReport.WorkflowReport = false;
        }
      }

      this.reportParameters.filter(o => o.ControlType == 'cbl').forEach(obj => {
        obj.Value = '';
        if (obj.DataSource != null) {
          obj.DataSource.filter(o => o.IsSelected == true).forEach(dsObj => {
            obj.Value += dsObj.ValueField + ',';
          });
        }
      });

      this.reportParameters.filter(o => o.ControlType == 'ddcbl').forEach(obj => {
        let objValue = '';
        if (obj.Value != '') {
          obj.Value.forEach(element => {
            objValue += element + ',';
          });
          if (objValue != '') {
            obj.Value = '';
            obj.Value = objValue;
          }
        }
      });

      this.reportParameters.filter(o => o.ControlType == 'grid').forEach(obj => {
        obj.Value = '';
        this.gridDataSource.filter(o => o.Selected == true).forEach(dsObj => {
          obj.Value += dsObj.Id + ',';
        });
      });

      this.reportParameters.filter(o => o.ControlType == 'stp').forEach(obj => {
        obj.Value = obj.selectedStaffNumbers;
      });

      this.validateRequiredFields();

      if (this.errors.length == 0) {
        let studentIds = '';
        const studentSelection = this.reportParameters.filter(o => o.ControlType == 'ssrbl')[0];
        if (studentSelection != null && studentSelection.Value != null && studentSelection.Value.toString() == 'Custom') {
          if (this.selectedStudentIds != undefined && this.selectedStudentIds.length > 0) {
            const students = new GenericList();
            this.selectedStudentIds.forEach(obj => {
              const student = new GenericListItem();
              students.DialogTitle = 'Select Student(s)';
              students.ColumnHeader = 'Student';
              student.Id = this.blnReportCardsGrade == false ? obj.Id.toString() : obj.StudentId.toString();
              student.TextField = this.studentName(obj) + ' (' + obj.StudentNumber + ')';

              student.ValueField = this.blnReportCardsGrade == false ? obj.Id.toString() : obj.StudentId.toString();
              student.IsSelected = true;
              if (this.selectedStudentIdsArray.length > 0) {
                const studentSelect = this.selectedStudentIdsArray.find(s => s.toString() == obj.StudentId.toString());
                if (studentSelect == null || studentSelect == undefined) {
                  student.IsSelected = false;
                }
              }
              students.Items.push(student);
            });
            const studentListSelectorDialogRef = this.studentListSelectorDialog.open(
              GenericListSelectorComponent,
              {
                data: students,
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                minWidth: '50vw',
                maxWidth: '100vw',
                minHeight: '75vh',
                maxHeight: '100vh'
              });

            studentListSelectorDialogRef.afterClosed().subscribe(resultValue => {
              if (resultValue != undefined) {
                const studentId: number[] = resultValue;
                this.selectedStudentIdsArray = [];
                for (let x = 0; x < studentIds.length; x++) {
                  this.selectedStudentIdsArray.push(studentId[x]);
                }
                resultValue.forEach(obj => {
                  studentIds = studentIds + obj + ',';
                });
                this.printReportWithValidation(studentIds);
              }
              else {
                this.errors.push({
                  fieldName: 'Student Selection',
                  fieldRef: null,
                  errorMsg: 'Select at least one student'
                });
              }
            });
          }
          else {
            if (this.selectedReport.ReportName == 'CreateProfileReport') {
              this.selectedReport.ReportParameters = this.reportParameters;
              this.reportingService.getV9ReportParameterValidation(this.selectedReport).subscribe(resultError => {
                if (resultError != '') {
                  const errormessage = resultError.split('|');
                  errormessage.forEach(obj => {
                    if (obj != '') {
                      this.errors.push({
                        fieldName: '',
                        fieldRef: null,
                        errorMsg: obj
                      });
                    }
                  });
                }
                else {
                  this.selectedReport.ReportParameters = [];
                  const studentSearchDialogRef = this.dialog.open(
                    StudentSearchComponent,
                    {
                      data: {
                        searchAndSelect: true,
                        returnSelectedStudents: true
                      },
                      disableClose: true,
                      width: '100%',
                      height: '100%',
                      maxHeight: '100vh',
                      maxWidth: '100vw'
                    });

                  studentSearchDialogRef.afterClosed().subscribe(result => {
                    if (result != undefined && result.length > 0) {
                      result.forEach(obj => {
                        studentIds = studentIds + obj.Id + ',';
                      });
                      this.printReportWithValidation(studentIds);
                    }
                    else {
                      this.errors.push({
                        fieldName: 'Student Selection',
                        fieldRef: null,
                        errorMsg: 'Select at least one student'
                      });
                    }
                  });
                }
              });

            }
            else {
              const studentSearchDialogRef = this.dialog.open(
                StudentSearchComponent,
                {
                  data: {
                    searchAndSelect: true,
                    returnSelectedStudents: true
                  },
                  disableClose: true,
                  width: '100%',
                  height: '100%',
                  maxHeight: '100vh',
                  maxWidth: '100vw'
                });

              studentSearchDialogRef.afterClosed().subscribe(result => {
                if (result != undefined && result.length > 0) {
                  result.forEach(obj => {
                    studentIds = studentIds + obj.Id + ',';
                  });
                  this.printReportWithValidation(studentIds);
                }
                else {
                  this.errors.push({
                    fieldName: 'Student Selection',
                    fieldRef: null,
                    errorMsg: 'Select at least one student'
                  });
                }
              });
            }
          }
        }
        else {
          this.printReportWithValidation(studentIds);
        }
      }
    }
  }

  closeClick() {
    this.dialogRef.close('Close was clicked.');
  }

  selectAllGridRecordsChange() {
    this.gridDataSource.forEach(row => {
      row['Selected'] = this.selectAllGridRecords;
    });
  }

  printReport(studentIds: string) {
    if (this.selectedStudentIds != undefined && this.selectedStudentIds.length > 0 && studentIds == '') {
      this.selectedStudentIds.forEach(obj => {
        studentIds = studentIds + obj.StudentId + ',';
      });
    }
    this.selectedReport.StudentIds = studentIds;
    this.reportParameters.filter(x => x.ControlType == 'img').forEach(obj => {
      obj.Value = '';
    });

    this.reportParameters.filter(x => x.ControlType == 'grid').forEach(obj => {
      obj.GridDataSources = null;
      obj.ColumnToDisplay = [];
    });

    this.selectedReport.ReportParameters = this.reportParameters;
    if (this.selectedReport.WorkflowReport == true && studentIds.length > 0) {
      if (studentIds.split(',').length <= this.selectedReport.MinimumStudentsForWorkflow) {
        this.selectedReport.WorkflowReport = false;
      }
    }

    if (this.selectedReport.WorkflowReport == false) {
      const studentAttachment: ReportV9 = {
        Id: this.selectedReport.Id,
        ParentId: this.selectedReport.ParentId,
        Description: this.selectedReport.Description,
        ReportName: this.selectedReport.ReportName,
        ReportTitle: this.selectedReport.ReportTitle,
        ReportType: this.selectedReport.ReportType,
        Active: this.selectedReport.Active,
        WorkflowReport: this.selectedReport.WorkflowReport,
        MinimumStudentsForWorkflow: this.selectedReport.MinimumStudentsForWorkflow,
        ReportParameterClassName: this.selectedReport.ReportParameterClassName,
        StudentIds: this.selectedReport.StudentIds,
        ReportsList: this.selectedReport.ReportsList,
        ReportParameters: this.selectedReport.ReportParameters,
        ReportValue: this.selectedReport.ReportValue,
        SchoolId: this.yearService.defaultYear.SchoolID,
        YearId: this.yearService.defaultYear.Id,
        SiteSectionId: this.selectedSiteSectionId
      };
      window.localStorage.setItem('v9ReportParameter', JSON.stringify(studentAttachment));
      window.open(System.baseUrl + 'studentattachment', '_blank');
    }
    else {
      this.reportingService.runV9ReportByParameter(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id, this.selectedSiteSectionId, 0, this.selectedReport).subscribe(result => {
        const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
          panelClass: 'tyl-mat-dialog',
          disableClose: true,
        });
      });
    }
    this.dialogRef.close('Close was clicked.');
  }

  parameterChanged(parameter: V9ReportParameter) {
    if (parameter.ControlType == 'chk') {
      this.reportParameters.filter(o => o.ParentId == parameter.Id).forEach(obj => {
        obj.Disabled = false;
        if (obj.ParentValue != null && parameter.Value != null) {
          if (obj.ParentValue.toUpperCase() != parameter.Value.toString().toUpperCase()) {
            obj.Disabled = true;
          }
        }
        this.reportParameters.filter(x => x.ParentId == obj.Id).forEach(element => {
          element.Disabled = false;
          if (obj.Value != null && element.Value != null) {
            if (element.ParentValue.toUpperCase() != obj.Value.toString().toUpperCase()) {
              element.Disabled = true;
            }
          }
        });
      });
    }
    if (parameter.ControlType == 'rbl') {
      this.reportParameters.filter(o => o.ParentId == parameter.Id).forEach(obj => {
        obj.Disabled = false;
        const parentValue = obj.ParentValue.split(',');
        if (parentValue.length > 1) {
          if (parentValue.indexOf(parameter.Value) > -1) {
            obj.Disabled = false;
          }
          else {
            obj.Disabled = true;
          }
        }
        else {
          if (obj.ParentValue != null && parameter.Value != null) {
            if (obj.ParentValue != parameter.Value) {
              obj.Disabled = true;
            }
          }
          this.reportParameters.filter(x => x.ParentId == obj.Id).forEach(element => {
            element.Disabled = obj.Disabled;
          });
        }
      });
    }
    if (parameter.ControlType == 'ddl') {
      this.reportParameters.filter(o => o.ParentId == parameter.Id).forEach(obj => {
        obj.Disabled = false;
        if (obj.ParentValue != null && parameter.Value != null) {
          if (obj.ParentValue.toUpperCase() != parameter.Value.toString().toUpperCase()) {
            obj.Disabled = true;
          }
        }
        this.reportParameters.filter(x => x.ParentId == obj.Id).forEach(element => {
          element.Disabled = false;
          if (obj.Value != null && element.Value != null) {
            if (element.ParentValue.toUpperCase() != obj.Value.toString().toUpperCase()) {
              element.Disabled = true;
            }
          }
        });
      });
    }
  }

  setParameterRows() {
    this.chunkedParameters = new V9ParameterRows();
    const reportParameter = this.reportParameters[this.reportParameters.length - 1];
    if (reportParameter != null) {
      for (let rowIndex = 0; rowIndex < reportParameter.RowNumberInTable; rowIndex++) {
        const parameterRow = new V9ParameterRow();
        let includeLineAtStartOfGroup = true;
        let includeLineAtEndOfGroup = true;
        this.reportParameters.filter(o => o.RowNumberInTable == rowIndex + 1 && o.IsLetterParameter == false).forEach(obj => {
          if (obj.DataType == 'BIT') {
            if (typeof (obj.Value) != 'boolean') {
              obj.Value = obj.Value != null && obj.Value.toUpperCase() == 'TRUE' ? true : false;
            }
          }
          if (obj.IncludeLineAtStartOfGroup != includeLineAtStartOfGroup) {
            includeLineAtStartOfGroup = false;
          }
          if (obj.IncludeLineAtEndOfGroup != includeLineAtEndOfGroup) {
            includeLineAtEndOfGroup = false;
          }
          if (obj.ParentId != null && obj.ParentId > 0) {
            const parentReportParameter = this.reportParameters.filter(o => o.Id == obj.ParentId)[0];
            if (parentReportParameter.ControlType == 'rbl') {
              const parentValue = obj.ParentValue.split(',');
              if (parentValue.length > 1) {
                if (parentValue.indexOf(parentReportParameter.Value) > -1) {
                  obj.Disabled = false;
                }
                else {
                  obj.Disabled = true;
                }
                obj.Disabled = obj.Disabled == false && parentReportParameter.Disabled == true ? true : obj.Disabled;
              }
              else {
                obj.Disabled = parentReportParameter.Disabled == true ? true : obj.ParentValue.toUpperCase() != parentReportParameter.Value.toString().toUpperCase();
              }
            }
            else {
              if (parentReportParameter != null && parentReportParameter.Value != null) {
                if (parentReportParameter.Disabled == true) {
                  obj.Disabled = true;
                }
                else {
                  if (obj.ParentValue.toUpperCase() != '') {
                    if (obj.ParentValue.toUpperCase() != parentReportParameter.Value.toString().toUpperCase()) {
                      obj.Disabled = true;
                    }
                  }
                }
                // obj.Disabled = parentReportParameter.Disabled == true ? true : obj.ParentValue.toUpperCase() != parentReportParameter.Value.toString().toUpperCase();
              }
            }
            if (obj.DataSource == null) {
              if (obj.LookupProcedureName != '') {
                let parentValue = '';
                if (parentReportParameter.DataSource != null && parentReportParameter.DataSource.length > 0) {
                  parentValue = parentReportParameter.Value == '' ? parentReportParameter.DataSource[0].ValueField : parentReportParameter.Value;
                }
                else {
                  parentValue = parentReportParameter.Value;
                }
                this.reportingService.getV9ReportParameterSelectionByLookupName(obj.Id, this.selectedSiteSectionId, parentValue, obj.LookupProcedureName, 0, obj.ControlType).subscribe(result => {
                  if (obj.ControlType == 'grid') {
                    obj.GridDataSource = result.GridDataSource;
                    obj.ColumnToDisplay = [];
                    if (obj.Disabled == false) {
                      obj.ColumnToDisplay = ['Selected'];
                    }
                    if (obj.GridDataSource != null && obj.GridDataSource != '') {
                      this.gridDataSource = JSON.parse(obj.GridDataSource);
                      obj.GridDataSources = new TylerMatTableDataSource(this.gridDataSource);
                      obj.GridDataSources.sort = this.sort;
                      if (this.gridDataSource.length > 0) {
                        obj.ColumnToDisplay = obj.ColumnToDisplay.concat(Object.keys(this.gridDataSource[0]));
                        if (obj.ColumnToDisplay.includes('Id')) {
                          obj.ColumnToDisplay.splice(obj.ColumnToDisplay.indexOf('Id'), 1);
                        }
                      }
                    }
                  }
                  else if (obj.ControlType == 'rtxt') {
                    obj.Value = result.Value;
                  }
                  else {
                    if (result.DataSource != null) {
                      obj.DataSource = result.DataSource;
                    }
                  }
                });
              }
            }
          }
          if (obj.ControlType == 'cbl') {
            if (obj.DataSource != null) {
              if (obj.DataSource.length > 0) {
                const variable = obj.Value.split(',');
                variable.forEach(ele => {
                  obj.DataSource.forEach(element => {
                    if (element.ValueField == ele) {
                      element.IsSelected = true;
                    }
                  });
                });
              }
            }
          }
          if (obj.ControlType == 'ddcbl') {
            const objValue: string[] = [];
            if (obj.DataSource != null && obj.DataSource.filter(x => x.TextField.trim() == 'ALL').length > 0) {
              obj.DataSource.forEach(obj => {
                objValue.push(obj.ValueField);
              });
            }
            else {
              if (obj.Value != '' && obj.Value != null) {
                const variable = obj.Value.split(',');
                variable.forEach(element => {
                  if (element != '') {
                    objValue.push(element);
                  }
                });
              }
            }
            if (objValue.length > 0) {
              obj.Value = objValue;
            }
          }
          if (obj.ControlType == 'grid') {
            if (obj.GridDataSource != null) {
              obj.ColumnToDisplay = [];
              if (obj.Disabled == false) {
                obj.ColumnToDisplay = ['Selected'];
              }
              if (obj.GridDataSource != null && obj.GridDataSource != '') {
                this.gridDataSource = JSON.parse(obj.GridDataSource);
                obj.GridDataSources = new TylerMatTableDataSource(this.gridDataSource);
                if (this.gridDataSource.length > 0) {
                  obj.ColumnToDisplay = obj.ColumnToDisplay.concat(Object.keys(this.gridDataSource[0]));
                  if (obj.ColumnToDisplay.includes('Id')) {
                    obj.ColumnToDisplay.splice(obj.ColumnToDisplay.indexOf('Id'), 1);
                  }
                }
                obj.GridDataSources.sort = this.sort;
              }
            }
          }
          if (obj.ControlType == 'lnk') {
            this.blnIsParameterLink = true;
            obj.IsVisible = false;
          }
          if (obj.ControlType == 'img') {
            if (obj.Value != '' && obj.Value != null) {
              if (obj.Value['changingThisBreaksApplicationSecurity'] == undefined && obj.Value['changingThisBreaksApplicationSecurity'] == null) {
                obj.Value = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64, ' + obj.Value);
              }
            }
          }
          if (obj.ControlType == 'ddl') {
            if (obj.Value != '') {
              if (obj.DataSource != null || obj.DataSource != undefined) {
                const objDataSourceValue = obj.DataSource.filter(x => x.ValueField == obj.Value);
                if (objDataSourceValue.length == 0) {
                  if (obj.DataSource != null && obj.DataSource.length > 0) {
                    obj.Value = obj.DataSource[0].ValueField;
                  }
                }
              }
              const childReportParameters = this.reportParameters.filter(o => o.ParentId == obj.Id);
              if (childReportParameters != undefined && childReportParameters.length > 0) {
                this.parameterSelectionChange(obj);
              }
            }
          }
          if (obj.ControlType == 'btn') {
            switch (obj.Value) {
              case "RefreshGrid":
                this.imageIconName = "refresh.png"
                break;
              case "AttendanceDay":
                this.imageIconName = "refresh.png"
                break;
              case "StaffSearch":
                this.imageIconName = "search normal.png"
                obj.Name = '';
                break;
              case "StaffSearchSelect":
                this.imageIconName = "search normal.png"
                obj.Name = '';
                break;
            }
          }
          if (obj.ControlType == 'stp') {
            this.imageIconName = "search normal.png";
            obj.staffpickerControlType = obj.Value;
          }

          parameterRow.Parameters.push(obj);
        });
        parameterRow.IncludeLineAtStartOfGroup = includeLineAtStartOfGroup;
        parameterRow.IncludeLineAtEndOfGroup = includeLineAtEndOfGroup;
        this.chunkedParameters.Rows.push(parameterRow);
      }
    }
  }

  validateRequiredFields() {
    this.reportParameters.filter(o => o.IsVisible == true && o.Disabled == false && o.IsRequired == true && o.IsLetterParameter == false).forEach(obj => {
      if (obj.Value == null || obj.Value.toString() == '') {
        let fieldName: string;
        if (obj.Name != null && obj.Name != '') {
          fieldName = obj.Name;
        }
        else if (obj.ParentId != null && obj.ParentId > 0) {
          const parentObject = this.reportParameters.filter(o => o.Id == obj.ParentId)[0];
          if (parentObject != null && parentObject.Name != null && parentObject.Name != '') {
            fieldName = parentObject.Name;
          }
        }
        fieldName = fieldName.replace(':', '');

        this.errors.push({
          fieldName: fieldName,
          fieldRef: null,
          errorMsg: 'Field is required'
        });
      }
    });
  }

  parameterSelectionChange(parameter: V9ReportParameter) {
    const reportParentParameter = this.reportParameters.filter(o => o.ParentId == parameter.Id);
    reportParentParameter.forEach(obj => {
      this.reportingService.getV9ReportParameterSelectionByLookupName(obj.Id, this.selectedSiteSectionId, parameter.Value, obj.LookupProcedureName, 0, obj.ControlType).subscribe(result => {
        if (obj.ControlType == 'grid') {
          obj.GridDataSource = result.GridDataSource;
          obj.ColumnToDisplay = [];
          if (obj.Disabled == false) {
            obj.ColumnToDisplay = ['Selected'];
          }
          if (obj.GridDataSource != null && obj.GridDataSource != '') {
            this.gridDataSource = JSON.parse(obj.GridDataSource);
            obj.GridDataSources = new TylerMatTableDataSource(this.gridDataSource);
            obj.GridDataSources.sort = this.sort;
            if (this.gridDataSource.length > 0) {
              obj.ColumnToDisplay = obj.ColumnToDisplay.concat(Object.keys(this.gridDataSource[0]));
              if (obj.ColumnToDisplay.includes('Id')) {
                obj.ColumnToDisplay.splice(obj.ColumnToDisplay.indexOf('Id'), 1);
              }
            }
          }
        }
        else if (obj.ControlType == 'rtxt') {
          obj.Value = result.Value;
        }
        else if (obj.ControlType == 'rbl') {

        }
        else if (obj.ControlType == 'ddl') {

        }
        else {
          obj.DataSource = result.DataSource;
        }
      });
    });
  }

  parameterLinkClick(parameterName: string) {
    if (parameterName == 'Print and Delivery Options') {
      const letterReportParameters = this.reportParameters.filter(x => x.IsLetterParameter == true);
      if (letterReportParameters.length > 0) {
        const letterPrintOptionDialogRef = this.dialog.open(V9LetterReportParametersComponent, {
          data: {
            reportParameters: this.reportParameters,
            selectedReport: this.selectedReport
          },
          disableClose: true,
          minWidth: '50vw',
          maxWidth: '100vw',
          minHeight: '50vh',
          maxHeight: '100vh'
        });
        letterPrintOptionDialogRef.afterClosed().subscribe(result => {
          if (result != undefined && result.length > 0) {
            this.reportParameters = result;
          }
        });
      }
    }
  }
  private _compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort, gridDataSource: TylerMatTableDataSource) {
    // Sort sorts the current list, but it wasnt updating it unless i reassigned.
    gridDataSource.data = gridDataSource.data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this._compare(a[sort.active], b[sort.active], isAsc);
    });
  }

  printReportWithValidation(studentIds: string) {
    if (this.selectedReport.ReportName == 'CreateGeneratingAcademicAwardsReport') {
      const postAwardstoProgramsandServices = this.reportParameters.find(o => o.ParameterName == 'blnPostAwardstoProgramsandServices');
      if (postAwardstoProgramsandServices != null) {
        if (postAwardstoProgramsandServices.Value == true) {
          this.selectedReport.ReportParameters = this.reportParameters.filter(o => o.ParentId == postAwardstoProgramsandServices.Id);
          this.selectedReport.ReportParameters.forEach((obj, index) => {
            const parentobject = this.reportParameters.filter(o => o.Id == obj.ParentId)[index];
            if (parentobject) {
              this.selectedReport.ReportParameters.push(parentobject);
            }
          });
          this.reportingService.getV9ReportParameterValidation(this.selectedReport).subscribe(result => {
            if (result != '') {
              const errormessage = result.split('|');
              errormessage.forEach(obj => {
                if (obj != '') {
                  this.errors.push({
                    fieldName: '',
                    fieldRef: null,
                    errorMsg: obj
                  });
                }
              });
            }
            else {
              this.printReport(studentIds);
            }
          });
        }
        //else { this.printReport(studentIds); }
      }
      else { this.printReport(studentIds); }
    }
    else if (this.selectedReport.ReportName == 'MissingGrades') {
      this.selectedReport.ReportParameters = this.reportParameters;
      this.reportingService.getV9ReportParameterValidation(this.selectedReport).subscribe(resultError => {
        if (resultError != '') {
          const errormessage = resultError.split('|');
          errormessage.forEach(obj => {
            if (obj != '') {
              this.errors.push({
                fieldName: '',
                fieldRef: null,
                errorMsg: obj
              });
            }
          });
        }
        else {
          this.selectedReport.ReportParameters = [];
          this.printReport(studentIds);
        }
      });
    }
    if (this.selectedReport.ReportName == 'CreateStaffPermissionsComparisonReport') {
      this.selectedReport.ReportParameters = this.reportParameters;
      this.reportingService.getV9ReportParameterValidation(this.selectedReport).subscribe(result => {
        if (result != '') {
          const errormessage = result.split('|');
          errormessage.forEach(obj => {
            if (obj != '') {
              this.errors.push({
                fieldName: '',
                fieldRef: null,
                errorMsg: obj
              });
            }
          });
        }
        else {
          this.printReport(studentIds);
        }
      });
    }
    else {
      this.printReport(studentIds);
    }
  }

  saveRCMessages() {
    this.reportForSaveRCM.ReportParameters = this.reportParameters.filter(x => x.ParameterName != '' && (x.TabName == 'Report Card Messages' || x.TabName == 'Messages'));
    this.reportingService.saveReportCardMessage(this.reportForSaveRCM).subscribe(result => {

    });
  }

  studentName(CL: GradebookStudent) {
    //  Formats student name based on general preferences

    let middle: string;
    let name: string;
    let nickName: string;

    //  Check gen pref and add middle name if selected
    switch (this.studentMiddleNameFormat) {
      case 'SEN':  //  Show Entire Name
        if (CL.MiddleName) {
          middle = ' ' + CL.MiddleName + ' ';
        } else {
          middle = ' ';
        }
        break;
      case 'SFL':  //  Show First Letter
        if (this.checkChar(CL.MiddleName)) {
          middle = ' ' + CL.MiddleName.charAt(0) + ' ';
        } else {
          middle = ' ';
        }
        break;
      default:  //  Do not show
        middle = ' ';
        break;
    }

    //  Check gen pref and add nickname if selected
    if (this.ShowNickname == '1' && CL.NickName != undefined && CL.NickName != '') {
      nickName = '"' + CL.NickName + '"';
    } else {
      nickName = '';
    }

    //  Check gen pref and format first/last name
    switch (this.studentNameFormat) {
      case 'FNF':  //  First Name First
        name = CL.FirstName + nickName + middle + CL.LastName;
        break;
      case 'LNF':  //  Last Name First
        name = CL.LastName + ', ' + CL.FirstName + ' ' + nickName + middle;
        break;
      case 'FILN': //  First Initial Last Name
        if (this.checkChar(CL.FirstName)) {
          name = CL.FirstName.charAt(0) + nickName + middle + CL.LastName;
        } else {
          name = nickName + middle + CL.LastName;
        }
        break;
      case 'FNLI': //  First Name Last Initial
        if (this.checkChar(CL.LastName)) {
          name = CL.FirstName + nickName + middle + CL.LastName.charAt(0);
        } else {
          name = CL.FirstName + nickName + middle;
        }
        break;
      default:
        return 'Invalid Format';
    }
    return name;
  }

  checkChar(str: string): boolean {
    return str != '' && str != null;
  }

  parameterDropdownlistSelectChange(parameter: V9ReportParameter, parameterValue: string) {
    let objValue: string[] = [];
    if (parameter.Value == '0') {
      parameter.DataSource.forEach(obj => {
        objValue.push(obj.ValueField);
      });
    }
    else {
      if (parameter.Value.length > 0) {
        const isParameterValue = parameter.Value.indexOf('0') > -1 && parameterValue == '0';
        const isUncheckAll = !parameter.Value.includes('0') && parameterValue == '0';
        if (parameter.DataSource.length != parameter.Value.length) {
          if (parameter.Value.includes('0')) {
            if (isParameterValue) {
              parameter.DataSource.forEach(obj => {
                objValue.push(obj.ValueField);
              });
            } else {
              parameter.Value.forEach(obj => {
                if (obj != '0') {
                  objValue.push(obj);
                }
              });
            }
          }
          else {
            parameter.Value.forEach(obj => {
              if (isParameterValue) {
                objValue.push(obj);
              }
              else {
                if (obj != '0') {
                  objValue.push(obj);
                }
              }
            });
            if (isUncheckAll) {
              objValue = [];
            }
          }
        }
        else {
          parameter.Value.forEach(obj => {
            objValue.push(obj);
          });
        }
      }
    }
    parameter.Value = objValue;
  }
  searchClick(parameter: V9ReportParameter) {
    if (this.selectedReport.ReportName == 'CreateStaffPermissionsComparisonReport' && parameter.ControlType == 'stp') {
      parameter.Value = parameter.staffpickerControlType;
    }
    if (parameter.Value == 'StaffSearch' || parameter.Value == 'StaffSearchSelect') {
      const schoolIds: number[] = [];
      this.yearService.schools.forEach(p => {
        if (!schoolIds.includes(p.Id)) {
          schoolIds.push(p.Id);
        }
      });
      const staffSearchDialog = this.dialog.open(StaffSearchComponent, {
        height: '100vh',
        width: '100vw',
        maxHeight: '100vh',
        maxWidth: '100vw',
        disableClose: true,
        data: {
          schoolIds: schoolIds,
          searchAndSelect: (parameter.Value == 'StaffSearchSelect' ? true : false)
        }
      });
      staffSearchDialog.afterClosed().subscribe((selectedStaff: Staff) => {
        if (selectedStaff) {
          this.chunkedParameters.Rows.forEach(parameterRow => {
            const index = parameterRow.Parameters.findIndex(o => o.ParameterName == parameter.ParameterName);
            if (index > -1) {
              if (Array.isArray(selectedStaff)) {
                let staffNumbers = '';
                let staffNames = '';
                selectedStaff.forEach(obj => {
                  staffNumbers = staffNumbers + obj.EmployeeNumber.trim() + ',';
                  staffNames = staffNames + obj.LastName + ', ' + obj.FirstName + ',';
                });
                if (parameterRow.Parameters[index].ControlType == 'stp') {
                  parameterRow.Parameters[index].selectedStaffNames = staffNames;
                  parameterRow.Parameters[index].selectedStaffNumbers = staffNumbers;
                } else {
                  parameterRow.Parameters[index - 1].Value = staffNumbers;
                }
              } else {
                if (parameterRow.Parameters[index].ControlType == 'stp') {
                  parameterRow.Parameters[index].selectedStaffNames = selectedStaff.LastName + ', ' + selectedStaff.FirstName;
                  parameterRow.Parameters[index].selectedStaffNumbers = selectedStaff.EmployeeNumber;
                } else {
                  parameterRow.Parameters[index - 1].Value = selectedStaff.EmployeeNumber;
                }
              }
            }
          });
        }
      });
    }
    if (parameter.Value == 'RefreshGrid') {
      this.refreshGrid = this.selectedReport;
      this.refreshGrid.ReportParameters = this.reportParameters.filter(o => o.ControlType != 'grid');
      const refreshGrid = this.reportParameters.filter(o => o.ControlType == 'grid')[0];
      this.reportingService.getV9ReportParameterBtnRefreshData('RefreshGrid', this.selectedReport).subscribe(result => {
        if (refreshGrid.ControlType == 'grid') {
          refreshGrid.GridDataSource = result.GridDataSource;
          if (refreshGrid.GridDataSource != '') {
            refreshGrid.ColumnToDisplay = [];
            if (refreshGrid.Disabled == false) {
              refreshGrid.ColumnToDisplay = ['Selected'];
            }
          }

          if (refreshGrid.GridDataSource != null && refreshGrid.GridDataSource != '') {
            this.gridDataSource = JSON.parse(refreshGrid.GridDataSource);
            refreshGrid.GridDataSources = new TylerMatTableDataSource(this.gridDataSource);
            refreshGrid.GridDataSources.sort = this.sort;
            if (this.gridDataSource.length > 0) {
              refreshGrid.ColumnToDisplay = refreshGrid.ColumnToDisplay.concat(Object.keys(this.gridDataSource[0]));
              if (refreshGrid.ColumnToDisplay.includes('Id')) {
                refreshGrid.ColumnToDisplay.splice(refreshGrid.ColumnToDisplay.indexOf('Id'), 1);
              }
            }
          }
          else {
            refreshGrid.GridDataSources.data = [];
          }
        }
      });
    }
    if (parameter.Value == 'AttendanceDay') {
      this.refreshGrid = this.selectedReport;
      this.refreshGrid.ReportParameters = this.reportParameters;
      this.reportingService.getV9ReportParameterBtnRefreshData('AttendanceDay', this.selectedReport).subscribe(result => {
        if (result.Name) {
          const calendarDay = this.reportParameters.filter(o => o.ColumnName == 'CalendarDay')[0];
          calendarDay.Name = result.Name;
        }
      });
    }
    if (parameter.Value == 'ReportCardMessage') {
      this.saveRCMessages();
    }
  }
}
